module.exports = __webpack_public_path__ + "static/media/4l_website_logo_sup_hkcs.83ed52f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4l_website_logo_sup_hkcs.jpg
// module id = 65
// module chunks = 0